<template>
    <div class="checkout-confirmation">
        <div v-for="group in result.items">
            <div class="checkout-confirmation__row"
                 v-for="item in group">
                <p>{{ item.title }}</p>
                <a class="def-free"
                   v-if="item.href"
                   :href="item.href"
                   v-html="item.value"
                >
                </a>
                <p v-else
                   :class="{'def-sale':item.sale}"
                   v-html="item.value"></p>
            </div>
            <br>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'checkout-confirmation',
        props: {
            result: {
                type: [Object, Array],
                default: () => ({
                    items: [
                        [
                            {title: 'some', value: 'some2'},
                            {title: 'some', value: 'some2'},
                        ],
                        [
                            {title: 'some', value: 'some2'},
                            {title: 'some', value: 'some2', sale: true},
                            {title: 'Доставка', value: 'Бесплатная', href: '#'},
                            {title: 'some', value: 'some2'},
                        ]
                    ],
                })
            },
        },
        mounted() {
            console.log(this.items);
            if (App.debug) {
                console.log('Component: checkout-confirmation', this.result);
            }
        }
    }
</script>

<style lang="scss">
    .checkout-confirmation{
        max-width: 500px;
        &__row{
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            font-size: rem(14);
            margin-bottom: 16px;
            color: #757575;
            @include point-md{
                font-size: rem(16);
                flex-direction: row;
            }
            & > *{
                @include point-md{
                    width: 50%;
                }
                &:first-child{
                    margin-bottom: 4px;
                    @include point-md{
                        margin-bottom: 0;
                    }
                }
                &:nth-child(2) {
                    font-weight: 500;
                    line-height: 110%;
                    color: var(--text-colour-primary);
                }
            }
        }
        .def-free{
            color: var(--text-colour-secondary);
        }
        .def-sale{
            color: #C80024;
            font-size: rem(14);
            @include point-md{
                font-size: rem(16);
            }
        }
    }
</style>